// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomPromptsModal_wrapper__CN1Io","promptInput":"CustomPromptsModal_promptInput__q2LSj"};